import React from 'react';
import { masterDetailListPaneStyle, masterDetailReadingPaneStyle } from 'src/constants/dimensions';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import styleUtils from 'src/utils/styles';
import Column from './Column';
import Row from './Row';
const MasterDetailLayout = ({ listPane, detailPane, showDetail = true, ...rest }) => {
    const [{ theme }] = useTheme();
    const listPaneStyle = {
        ...masterDetailListPaneStyle,
        borderRightWidth: 1,
        borderRightColor: theme.palette.divider.main,
    };
    return (React.createElement(Row, { flex: true, ...rest },
        React.createElement(Column, { style: showDetail ? listPaneStyle : styleUtils.containerWidth }, listPane),
        showDetail && (React.createElement(Column, { flex: true, style: masterDetailReadingPaneStyle }, detailPane))));
};
export default MasterDetailLayout;
